import React, { useState, useEffect } from 'react';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import LegendsComponent from '../LegendsComponent/LegendsComponent';
import QueriesComponent from '../QueriesComponent/QueriesComponent';
import './RightSidebar.css';

const RightSidebar = () => {
    const {
        sidebarOpenRight,
        setSidebarOpenRight,
        activeTabContentSidebarRight,
        setActiveTabContentSidebarRight,
        config
    } = useGlobalVariablesContext();

    const infoPanelEnabled = config?.TOOLS?.infoPanel?.enable !== false;

    // TODO: Pestañas CONSULTAS y AYUDA comentadas temporalmente - descomentar cuando se necesiten
    const tabs = [
        // { id: 'consultas', label: 'CONSULTAS', icon: 'bi-search' },
        ...(infoPanelEnabled ? [{ id: 'sobre', label: 'INFO', icon: 'bi-info-circle' }] : []),
        { id: 'leyenda', label: 'LEYENDA', icon: 'bi-list-ul' },
        // { id: 'ayuda', label: 'AYUDA', icon: 'bi-question-circle' }
    ];

    const defaultTab = infoPanelEnabled ? 'sobre' : 'leyenda';
    const [activeTab, setActiveTab] = useState(defaultTab);

    useEffect(() => {
        if (!infoPanelEnabled && activeTab === 'sobre') {
            setActiveTab('leyenda');
        }
    }, [infoPanelEnabled]);

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setActiveTabContentSidebarRight(tabId);
    };

    const toggleSidebar = () => {
        setSidebarOpenRight(!sidebarOpenRight);
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case 'leyenda':
                return <LegendsComponent />;
            // TODO: Descomentar cuando se reactive la pestaña CONSULTAS
            // case 'consultas':
            //     return <QueriesComponent />;
            case 'sobre': {
                const rawContent = config?.TOOLS?.infoPanel?.params?.content || '';
                const infoContent = rawContent.replace(/&nbsp;/g, ' ');
                return (
                    <div>
                        {config?.visorName && (
                            <div className="legends-header">
                                <h5 className="legends-title">
                                    <i className="bi bi-info-circle me-2"></i>
                                    {config.visorName}
                                </h5>
                            </div>
                        )}
                        {infoContent ? (
                            <div className="p-3" dangerouslySetInnerHTML={{ __html: infoContent }} />
                        ) : null}
                    </div>
                );
            }
            // TODO: Descomentar cuando se reactive la pestaña AYUDA
            // case 'ayuda':
            //     return (
            //         <div className="p-3">
            //             <h6>Ayuda</h6>
            //             <p>Información de ayuda...</p>
            //         </div>
            //     );
            default:
                return null;
        }
    };

    return (
        <>
            {/* Botón para abrir/cerrar sidebar */}
            <button
                className="btn btn-primary position-absolute sidebar-toggle-btn"
                style={{
                    top: '12px',
                    right: '70px',
                    zIndex: 1
                }}
                onClick={toggleSidebar}
                title="Abrir panel derecho"
            >
                <i className="bi bi-list"></i>
            </button>

            {/* Sidebar derecho */}
            <div className={`right-sidebar ${sidebarOpenRight ? 'show' : ''}`}>
                <div className="right-sidebar-content">
                    {/* Header con tabs */}
                    <div className="right-sidebar-header">
                        <ul className="nav nav-tabs nav-fill">
                            {tabs.map((tab) => (
                                <li className="nav-item" key={tab.id}>
                                    <button
                                        className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                                        onClick={() => handleTabClick(tab.id)}
                                        type="button"
                                    >
                                        <i className={`${tab.icon} me-1`}></i>
                                        <span className="d-none d-sm-inline">{tab.label}</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contenido del sidebar */}
                    <div className="right-sidebar-body">
                        {renderTabContent()}
                    </div>

                    {/* Footer con botón de cerrar */}
                    <div className="right-sidebar-footer">
                        <button
                            className="btn btn-outline-secondary btn-sm w-100"
                            onClick={toggleSidebar}
                        >
                            <i className="bi bi-x-lg me-1"></i>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>

            {/* Overlay para cerrar al hacer click fuera */}
            {sidebarOpenRight && (
                <div
                    className="sidebar-overlay"
                    onClick={toggleSidebar}
                ></div>
            )}
        </>
    );
};

export default RightSidebar;
